var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.5V13H32.5H45C47.4739 13 49.5 15.0261 49.5 17.5V45C49.5 47.4739 47.4739 49.5 45 49.5H5C2.52614 49.5 0.5 47.4739 0.5 45V17.5C0.5 15.0261 2.52614 13 5 13H17.5H18V12.5V5C18 2.52614 20.0261 0.5 22.5 0.5H27.5C29.9739 0.5 32 2.52614 32 5V12.5ZM22.5 4.5H22V5V12.5V17.5V18H22.5H27.5H28V17.5V12.5V5V4.5H27.5H22.5ZM45 45.5H45.5V45V17.5V17H45H32.5H32V17.5C32 19.9739 29.9739 22 27.5 22H22.5C20.0261 22 18 19.9739 18 17.5V17H17.5H5H4.5V17.5V45V45.5H5H45Z",
    fill: "#3B82F6",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.57bbb00e1a2e88ab51a915c047d3af95.svg";
export { ForwardRef as ReactComponent };